module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1018-95bbd38e0cdcb3868118edb9507770d9.png";